'use client';
import { scaleBand } from 'd3-scale';
import { useMemo } from 'react';
import { useSvgContext } from '../../context';
import { BAND } from './constants';

export default function useScaleBandY(data: any, paddingInner: any, paddingOuter: any) {
  const { bottom, height } = useSvgContext();
  return useMemo(() => {
    const scale: any = scaleBand()
      .domain(data.map((_d: any, i: any) => i))
      .range([0, height - bottom])
      .paddingInner(paddingInner)
      .paddingOuter(paddingOuter);
    scale.type = BAND;
    return scale;
  }, [data, bottom, height, paddingInner, paddingOuter]);
}
